import { FieldValues, FormState, useFormState, UseFormReturn } from "react-hook-form";

/**
 * Subscribes to dirty fields during render so submit handlers receive the current
 * field map, including nested changes made through useFieldArray.
 */
export function useSubscribedDirtyFields<T extends FieldValues>(form: UseFormReturn<T>) {
    return useFormState({ control: form.control }).dirtyFields;
}

export function getDirtyValues<T extends FieldValues>(values: T, dirtyFields: FormState<T>["dirtyFields"]): Partial<T> {
    const dirtyFieldNames = Object.entries(dirtyFields)
        .filter(([, isDirty]) => isDirty)
        .map(([fieldName]) => fieldName as keyof T);
    return Object.fromEntries(dirtyFieldNames.map((fieldName) => [fieldName, values[fieldName]])) as Partial<T>;
}
